import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { TextSearchResultResponse } from "@src/types/textSearchResult";

export const useTextSearchResult = (
  pageNumber: number = 1,
  enabled?: boolean,
  pageSize?: number,
  priceMode?: number,
  certNumber: string = "",
  productType?: string,
  groupSettings?: any,
  productSubType?: string
) => {
  return useQuery({
    queryKey: ["page_number", pageNumber, certNumber],
    enabled: enabled,
    keepPreviousData: true,
    queryFn: () =>
      apiClient.get<TextSearchResultResponse>(Routes.SEARCH_CERTS, {
        params: {
          term: certNumber,
          page_number: pageNumber,
          per_page: pageSize,
          price_mode: priceMode,
          product_type: productType ? productType : "all_product",
          group_settings: groupSettings,
          product_sub_type: productSubType,
        },
        headers: {
          ...apiClient.defaults.headers.common,
          "If-None-Match": "",
        },
      }),
  });
};
